<template>
    <div>
        <div :id=uid class="modal">
            <div class="modal-content">
                <img style="max-height: 50vh" :src="image.url"/>
            </div>
            <div class="modal-footer">
                <div style="position: fixed;top: 1px;right: 1px;"><button class="modal-close btn-flat cancelbutton">X</button></div>
            </div>
        </div>
        <div><img style="max-height: 80px" :src="image.thumb.url"   v-on:click="open()"/></div>
    </div>
</template>
<script>
import axios from 'axios';
import _ from 'lodash';
export default {
    data: function() {
      return {
        uid: _.uniqueId(this.identifier),
        instances: []
      }
    },
    props: {
        image: Object
    },
    mounted: function() {
      var elems = this.$el.querySelectorAll('.modal');
      this.instances = M.Modal.init(elems, {preventScrolling: true, startingTop: '0%',});
    },
    methods: {
        open: function(){
            this.instances[0].open();
        }
    }
}
</script>
<style scoped>
.modal-content{
    text-align: start !important;
}
p{
    text-align: center;
}
.cancelbutton{
    border: 1px solid black;
    border-radius: 8px;
}
.btn-small{
    margin: 15px;
}
.modal-trigger{
    margin: initial;
}
</style>